export default "__VITE_ASSET__CVPjD3gC__"